import React from 'react';
import { useState, useEffect } from 'react';
import { BsSearch } from 'react-icons/bs';
import { VscDebugContinueSmall } from 'react-icons/vsc';
import '../../style/home.scss'

function Home({ homeAnimation, setHomeAnimation }) {
  const [search, setSearch] = useState('');

  function googleSearch(e, search) {
    if (e === 'Enter' && search !== '') {
      window.location.href = 'https://www.google.com/search?q=' + search;
    }
  }

  useEffect(() => {
    setSearch('');
    setTimeout(() => {
      setHomeAnimation(false);
    }, 7000);
    return () => {
      setHomeAnimation(false);
    };
  }, [setHomeAnimation]);

  return (
    <div
      className={`homeContainer ${
        homeAnimation ? 'animate' : 'animationCompleted'
      }`}
    >
      <div className={'homeInputContainer'}>
        <BsSearch
          onClick={() => googleSearch('Enter', search)}
          className="homeSearchIcon"
        />
        <input
          className={'homeSearchBar'}
          placeholder={'Search something using Google...'}
          onChange={e => setSearch(e.target.value)}
          onKeyDown={e => googleSearch(e.key, search)}
        />
        <VscDebugContinueSmall
          onClick={() => googleSearch('Enter', search)}
          className="homeSearchIcon"
        />
      </div>
    </div>
  );
}

export default Home;
